// extracted by mini-css-extract-plugin
module.exports = {"label":"TopOrganizerLabel_label__MiliA","crownIcon":"TopOrganizerLabel_crownIcon__hoD1w"};